define('ordersMainRouter',[
  'module',
  'require',
  'windows',
  'ordersDetailView',
  'jquery',
  'logger',
  'underscore',
  'marionette',
  'app',
  'settings',
  'contentShowController',
  'itemPagesNameMixin',
  'entities/orders',
  'entities/customers/customers'
], function (
  Module,
  require,
  Windows,
  DetailView,
  $,
  Logger,
  _,
  Marionette,
  App,
  Settings,
  ContentShowController,
  ItemPagesNameMixin
) {
  'use strict';

  var OrdersRouter = Marionette.AppRouter.extend({
    appRoutes: {
      'orders': 'showOrdersList',
      'orders_unpaid': 'showUnpaidOrdersList',
      'offers': 'showOffersList',
      'orders_kanban/filter/:endUserId': 'showOrdersBoardFiltered',
      'offers_kanban/filter/:endUserId': 'showOffersBoardFiltered',
      'orders_kanban(/:tabName)': 'showOrdersBoard',
      'offers_kanban(/:tabName)': 'showOffersBoard',

      'orders/(customers/:customerSecId/orders/):orderSecId': 'showDefaultTab',
      'orders/(customers/:customerSecId/orders/):orderSecId(/:tabName)': 'showTab',
      'orders/(customers/:customerSecId/producttemplates/):orderSecId': 'showDefaultTab',
      'orders/(customers/:customerSecId/producttemplates/):orderSecId(/:tabName)': 'showTab'
    }
  });

  Module.exports = OrdersRouter;

  var API = {
    showOrdersList: function () {
      require([
        'ordersListView'
      ], function (View) {
        ContentShowController.showContent().done(function () {
          App.currentUrl = App.getCurrentRoute();
          Settings.set('currentView', 'orderList', true); 
          var view = new View({type: 'command'});
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.execute('set:active:nav:item', ItemPagesNameMixin.ORDERS_LIST);
        });
      });
    },

    showUnpaidOrdersList: function () {
      require([
        'ordersUnpaidView'
      ], function (View) {
        ContentShowController.showContent().done(function () {
          App.currentUrl = App.getCurrentRoute();
          Settings.set('currentView', 'unpaidOrderList', true);
          var view = new View();
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.execute('set:active:nav:item', ItemPagesNameMixin.ORDERS_UNPAID);
        });
      });
    },

    showOffersList: function () {
      require([
        'ordersListView'
      ], function (View) {
        ContentShowController.showContent().done(function () {
          App.currentUrl = App.getCurrentRoute();
          Settings.set('currentView', 'offerList', true); 
          var view = new View({type: 'offer'});
          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.execute('set:active:nav:item', ItemPagesNameMixin.OFFERS_LIST);
        });
      });
    },

    showDefaultTab: function (customerSecId, poi) {
      API.showTab(customerSecId, poi, 'details');
    },

    showTab: function (customerSecId, poi, tab) {   
      ContentShowController.showContent().done(function () {
        DetailView.prototype.open(poi, tab);
        //App.execute('set:active:nav:item', ItemPagesNameMixin.ORDERS_LIST);

        /*var currentView = Settings.get('currentView', true);

        if(currentView === 'orderList')
          API.showOrdersList();
        else if(currentView === 'offerList')  
          API.showOffersList();
        else if(currentView === 'orderBoard')
          API.showOrdersBoard();
        else if(currentView === 'offerBoard')
          API.showOffersBoard();  */         
      });
    },

    showOrdersBoardFiltered: function (endUserId) {
      this.showOrdersBoard(null, endUserId);
    },

    showOffersBoardFiltered: function (endUserId) {
      this.showOffersBoard(null, endUserId);
    },

    showOrdersBoard: function (parentStatus, endUserId, keepPopupOpen) {
      require([
        'ordersBoardView',
        'contentShowController'
      ], function (View, ContentShowController) {
        App.currentUrl = App.getCurrentRoute();
        Settings.set('currentView', 'orderBoard', true); 

        if(endUserId)
          App.navigate('orders_kanban', {trigger: false});

        ContentShowController.showContent(!keepPopupOpen).done(_.bind(function () {
          var view = new View({
            parentStatus: parentStatus,
            endUserId: endUserId,
            type: 'command'
          });

          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.execute('set:active:nav:item', ItemPagesNameMixin.ORDERS_BOARD);
        }, this));
      });
    },

    showOffersBoard: function (parentStatus, endUserId, keepPopupOpen) {
      require([
        'ordersBoardView',
        'contentShowController'
      ], function (View, ContentShowController) {
        App.currentUrl = App.getCurrentRoute();
        Settings.set('currentView', 'offerBoard', true);

        if(endUserId)
          App.navigate('offers_kanban', {trigger: false});

        ContentShowController.showContent(!keepPopupOpen).done(_.bind(function () {
          var view = new View({
            parentStatus: parentStatus,
            endUserId: endUserId,
            type: 'offer'
          });

          App.regions.getRegion('main').currentView.getRegion('content').show(view);
          App.execute('set:active:nav:item', ItemPagesNameMixin.OFFERS_BOARD);
        }, this));
      });
    }
  };

  App.on('before:start', function () {
    new OrdersRouter({
      controller: API
    });
  });
});

